import React from "react"
import PropTypes from "prop-types"
import { StyledStatusText } from "./styles"

// Array of statuses that should be colored
const WARNING_STATUSES = ["Failed"]

const StatusCell = ({ value, warningStatuses = WARNING_STATUSES }) => {
  const isDanger = value && warningStatuses.includes(value)
  return <StyledStatusText isDanger={isDanger}>{value || "-"}</StyledStatusText>
}

StatusCell.propTypes = {
  value: PropTypes.string,
  warningStatuses: PropTypes.arrayOf(PropTypes.string)
}

StatusCell.defaultProps = {
  value: "",
  warningStatuses: WARNING_STATUSES
}

export default StatusCell
